

import Invoice from "@/store/modules/shipment/declarecustoms/invoice";
import { appConst, Component, FormPageMixins} from "@/lib";
import CardTitleView from "@/components/card-title/index.vue"

@Component({components: { CardTitleView}})
export default class InvoiceView extends FormPageMixins  {
  model = new Invoice();
  loading:boolean = false;

  config: any = {
        model: new Invoice(),
        getAction: "shipment/declarecustoms/getInvoice",
        isHideOk: true
  }

 setSizeUnit(unit) {
    return unit === this.$appconst.unit.size;
  }
  setdotNumber(isSizeUnit) {
    return isSizeUnit ? 2 : 0;
  }

  quantity(row) {
    let dotNumber = this.setdotNumber(this.setSizeUnit(row.unit));
    return !!row.quantity || row.quantity === 0 ? row.quantity.toFixed(dotNumber) : row.quantity
  }

  get record() {
      return this.$store.state["shipment"]["declarecustoms"].invoiceData;
  }

  async created() {

  }

  get column() {
    return [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 100, {key: "rowIndex", align: 'center'}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductName", null, {key: "productName",slot: "productName", align: 'left',minWidth:350}),
      this.$util.render.baseColumn("app.DeclareGroup.Quantity", null, {key: "quantity", minWidth: 150, render: (h: any, params: any) => {
        let text = this.quantity(params.row);
        return [h("span", text!=undefined?text+" "+ params.row.unitDescription:"")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.Price", null, {key: "price", minWidth: 150, render: (h: any, params: any) => {
        return [h("span", params.row.price!=undefined?params.row.currency +" "+ this.$util.format.amount(params.row.price):"")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalAmount", null, {key: "totalAmount", minWidth: 150, render: (h: any, params: any) => {
        return [h("span", params.row.totalAmount!=undefined?params.row.currency +" "+ this.$util.format.amount(params.row.totalAmount):"")];
      }})
    ];
  }

  handleSpan ({ row, columnIndex }) {
    if (columnIndex == 0) {
      return {
          rowspan: row.rowspan,
          colspan: 1
      };
    }
  }

  handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.Common.Total');
    const NA = '';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0 || index === 3) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        if (index === 1) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        let haveSizeUnit = (data as Array<any>).some((item)=> {
          return this.setSizeUnit(item.unit);
        });
        let dotNumber = this.setdotNumber(haveSizeUnit);
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
            let amountText = "";
            switch(key) {
              case "totalAmount": 
                amountText = this.$util.format.amount(v);
                break;
              case "boxCount":
                amountText = v.toFixed(0);
                break;
              case "quantity":
                amountText = v.toFixed(dotNumber);
                break;
              default:
                amountText = v.toFixed(2);
                break;
            }
            sums[key] = {
                key,
                value: amountText
            };
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }

  get shipmentList() {
    let list = [];
    if (!!this.model.invoiceList && this.model.invoiceList.length > 0) {
      const poNumberText = this.L('app.DeclareGroup.PoNumber');
      this.model.invoiceList.forEach((item, index) => {
        // 当PO#和总品名都没有填写，则Talbe中不增加组名行
        let hasGroup = false;
        let childLength = item.productList.length;
        if (!!item.poNumber || !!item.groupName) {
          list.push({
            rowspan: childLength + 1,
            isGroup: true,
            isTitle: true,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            poNumber: !!item.poNumber ? `${poNumberText}${item.poNumber}` : "",
            groupName: item.groupName
          })
          hasGroup = true;
        }
        
        item.productList.forEach((productItem, productItemIndex) => {
          list.push({
            rowspan: hasGroup || productItemIndex !== 0 ? 0 : childLength,
            isGroup: false,
            isTitle: !hasGroup,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            productName: `${productItem.productNameEn}/${productItem.productName}`,
            quantity: productItem.quantity,
            unitDescription: this.getCodeDescription(appConst.codeCategory.unit,productItem.unit),
            price: productItem.price,
            currency: this.model.currency,
            totalAmount: productItem.totalAmount,
            unit: productItem.unit
          })
        })
      })
    };
    return list;
  }
 async  nextstep() {
 this.$router.push({ name: "declareCustoms.packing", query: {id:this.model.id.toString()} });  
}
  async download(){
    this.loading = true;
    let response = await this.$store.dispatch({
      type: "shipment/declarecustoms/exportInvoiceForm",
      data: { id: this.model.id }
    });

    this.loading = false;
    let name = response.headers["content-disposition"].split("=")[1];
    this.$util.downloadFile(response.data, decodeURI(name));
  }

  rowClassName (row, index) {
    if (row.isTitle) {
      return 'hi-table-group-row';
    }
    return '';
  }
}
